<template>
  <div>
    <PageAllow controller="DistributionShopAnalyze" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-btn
                v-show="distribution_shop_analyze.length"
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleBarEcharts')"
              >
                {{
                  $store.state.showBarEchartsPanel
                    ? $t("App.hideSparkline")
                    : $t("App.showSparkline")
                }}
                <v-icon small class="ps-1">{{
                  $store.state.showBarEchartsPanel
                    ? "fa-angle-up"
                    : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 导出/下载 按钮 -->
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="download()"
                v-if="
                  $permission.permissionAllow(
                    'DistributionShopAnalyze',
                    'batchDetailExport'
                  )
                "
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("distributionShopAnalyze.Export.download") }}
              </v-btn>
              <v-btn
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="exportExcel()"
                v-if="
                  $permission.permissionAllow(
                    'DistributionShopAnalyze',
                    'export'
                  )
                "
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("distributionShopAnalyze.Export.excel") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 客户 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherShops
                    v-model="shopsSelected"
                    :districtCodes="districtCodes"
                    :districtID="districtID"
                    :allianceBusinessIds="options.alliance_business_ids"
                  />
                </v-col>
                <!-- 分组 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    settings && settings.report_hide_search_district_tree == 2
                  "
                >
                  <SearcherDistrictsWithDescendants
                    v-model="DistrictsSelected"
                    :label="
                      $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                    "
                  />
                </v-col>
                <!-- 销售 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherAlliances v-model="alliancesSelected" />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterial v-model="materialSelected" />
                </v-col>
                <!-- 状态 -->
                <v-spacer />
                <v-col cols="12" sm="6" md="4">
                  <SearcherDistributionStatus
                    :items="$consts.distribution.distribution_status"
                    v-model="options.status"
                    :label="$t('MaterialDistribution.Fields.status')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel
            v-show="sparklineValues.length"
            class="transparent-background-color"
          >
            <v-expansion-panel-content>
              <BarEcharts :labels="sparklineLabels" :values="sparklineValues" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="distribution_shop_analyze"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <!-- 合计 -->
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td colspan="2">
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <!-- <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ order_num_total | formatTwoDot(true) }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ order_price_total | formatMoney }}</span
                  >
                </td> -->
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>{{ distribution_num_total | formatTwoDot(true) }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span
                    >{{ $t("Global.money")
                    }}{{ distribution_price_total | formatMoney }}</span
                  >
                </td>
                <td></td>
              </tr>
              <!-- 小屏幕 -->
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("distributionShopAnalyze.order_num_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ order_num_total | formatTwoDot(true) }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("distributionShopAnalyze.order_price_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ order_price_total | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("distributionShopAnalyze.distribution_num_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ distribution_num_total | formatTwoDot(true) }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("distributionShopAnalyze.distribution_price_total") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money")
                    }}{{ distribution_price_total | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>

            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>

            <!-- 商品配送量 -->
            <template v-slot:item.num_sum="{ item }">
              {{ item.num_sum | formatTwoDot(true) }}
            </template>
            <!-- 商品配送金额 -->
            <template v-slot:item.price_sum="{ item }">
              {{ $t("Global.money") }}{{ item.price_sum | formatMoney }}
            </template>
            <!-- 下单金额 -->
            <template v-slot:item.order_price_total="{ item }">
              {{ $t("Global.money") }}{{ item.order_price_total | formatMoney }}
            </template>
            <!-- 下单量 -->
            <template v-slot:item.order_num_total="{ item }">
              {{ item.order_num_total | formatTwoDot(true) }}
            </template>
            <!-- 明细 -->
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    color="info"
                    class="px-2 me-2"
                    :href="
                      '/#/distribution-shop-analyze/detail?shop_id=' +
                      item.shop_id
                    "
                    v-if="
                      $permission.permissionAllow(
                        'DistributionShopAnalyze',
                        'view'
                      )
                    "
                  >
                    <v-icon x-small class="pe-1">fa-align-left</v-icon>
                    {{ $t("distributionShopAnalyze.detail") }}
                  </v-btn>
                </template>
                <span>{{
                  $t("CRUD.viewInfo", [$t("distributionShopAnalyze.detail")])
                }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import distributionShopAnalyze from "@/api/distribution_shop_analyze";
import SearcherAlliances from "@/components/plugins/SearcherAlliances";
import SearcherShops from "@/components/plugins/SearcherShops";
import SearcherDistributionStatus from "@/components/plugins/SearcherDistributionStatus";
import SearcherMaterial from "@/components/plugins/SearcherMaterial";
import consts from "@/consts";
import BarEcharts from "@/components/plugins/BarEcharts";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  datetimeRadioSelected: "create",
  create_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  create_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  distribution_time_from: "",
  distribution_time_to: "",
  material_id: null,
  alliance_business_ids: [],
  shop_ids: [],
  status: [1, 2, 3],
  district_ids: [],
};

export default {
  data: () => ({
    distribution_shop_analyze: [],
    paging: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    loading: false,
    alliancesSelected: null,
    shopsSelected: null,
    materialSelected: null,
    distribution_num_total: 0,
    distribution_price_total: 0,
    order_price_total: 0,
    order_num_total: 0,
    DistrictsSelected: [],
    districtCodes: [],
  }),
  components: {
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    PageAllow,
    SearcherAlliances,
    SearcherShops,
    SearcherDistributionStatus,
    SearcherMaterial,
    BarEcharts,
    SearcherDistrictsWithDescendants,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.distributionShopAnalyze", [consts.shopName()]),
        disabled: true,
      },
    ],
    datetimeRadios: () => [
      {
        key: "create",
        text: i18n.t("distributionShopAnalyze.created_time"),
      },
      {
        key: "distribution",
        text: i18n.t("distributionShopAnalyze.distribution_time"),
      },
    ],
    headers() {
      var headers = [
        {
          text: i18n.t("distributionShopAnalyze.Fields.shop_code"),
          align: "start",
          sortable: false,
          value: "shop_code",
        },
        {
          text: i18n.t("distributionShopAnalyze.Fields.shop_name"),
          align: "end",
          sortable: false,
          value: "shop_name",
        },
        // {
        //   text: i18n.t("distributionShopAnalyze.Fields.order_num_total"),
        //   align: "end",
        //   sortable: false,
        //   value: "order_num_total",
        // },
        // {
        //   text: i18n.t("distributionShopAnalyze.Fields.order_price_total"),
        //   align: "end",
        //   sortable: false,
        //   value: "order_price_total",
        // },
        {
          text: i18n.t("distributionShopAnalyze.Fields.num_sum"),
          align: "end",
          sortable: false,
          value: "num_sum",
        },
        {
          text: i18n.t("distributionShopAnalyze.Fields.price_sum"),
          align: "end",
          sortable: false,
          value: "price_sum",
        },
        {
          text: i18n.t("distributionShopAnalyze.Fields.actions"),
          align: "center",
          sortable: false,
          value: "actions",
        },
      ];
      return headers;
    },
    sparklineLabels() {
      return this.distribution_shop_analyze.map((item) => {
        return item.shop_name;
      });
    },
    sparklineValues() {
      return this.distribution_shop_analyze.map((item) => {
        return parseFloat(item.price_sum);
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["districtID", "settings"]),
  },

  mounted() {
    this.$store.commit("districtID", 0);
    this.$store.commit(
      "searchDistrict",
      this.settings && this.settings.report_hide_search_district_tree == 1
        ? true
        : false
    );
    this.$commonUtils
      .loadOptions("distribution-shop-analyze", [
        "alliancesSelected",
        "shopsSelected",
        "materialSelected",
        "DistrictsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();
          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "alliancesSelected":
                this.alliancesSelected = selected.value;
                break;
              case "shopsSelected":
                this.shopsSelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },
  methods: {
    onSearch() {
      // 搜索
      this.options = Object.assign({}, this.options);
      this.getDistributionSAFromAPI();
    },
    resetSearch() {
      this.alliancesSelected = [];
      this.shopsSelected = [];
      this.DistrictsSelected = [];
      this.materialSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getDistributionSAFromAPI() {
      this.loading = true;
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      distributionShopAnalyze.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.distribution_shop_analyze =
              response.data.distribution_shop_analyze;
            this.distribution_num_total = response.data.distribution_num_total;
            this.distribution_price_total =
              response.data.distribution_price_total;
            this.order_price_total = response.data.order_price_total;
            this.order_num_total = response.data.order_num_total;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    exportExcel() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      distributionShopAnalyze.exports(options);
    },
    download() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      distributionShopAnalyze.batchDetailExports(options);
    },
  },
  watch: {
    districtID: {
      handler() {
        this.getDistributionSAFromAPI();
      },
    },
    options: {
      deep: true,
      handler() {
        this.getDistributionSAFromAPI();
        sessionStorage.setItem(
          "distribution-shop-analyze-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 销售
    alliancesSelected: {
      handler() {
        this.options.alliance_business_ids = this.alliancesSelected
          ? this.alliancesSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "distribution-shop-analyze-alliancesSelected",
          JSON.stringify(this.alliancesSelected)
        );
      },
    },
    // 门店
    shopsSelected: {
      handler() {
        this.options.shop_ids = this.shopsSelected
          ? this.shopsSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "distribution-shop-analyze-shopsSelected",
          JSON.stringify(this.shopsSelected)
        );
      },
    },
    // 商品
    materialSelected: {
      handler() {
        this.options.material_id = this.materialSelected
          ? this.materialSelected.id
          : null;
        sessionStorage.setItem(
          "distribution-shop-analyze-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    DistrictsSelected: {
      handler() {
        if (this.settings &&
          this.settings.report_hide_search_district_tree == 2)
        { 
          this.options.district_ids = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
            : [];
          this.districtCodes = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.code;
            })
            : [];
          sessionStorage.setItem(
            "distribution-shop-analyze-DistrictsSelected",
            JSON.stringify(this.DistrictsSelected)
          );
        }
      },
    },
    settings: {
      handler() {
        this.$store.commit(
          "searchDistrict",
          this.settings && this.settings.report_hide_search_district_tree == 1
            ? true
            : false
        );
      },
    },
  },
};
</script>

<style>
</style>